import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class SharedCacheService {

  /**
   * @name generateGuid
   * @description
   * generate a Guid for cache
   * @memberof SharedCacheService
   * @returns {string}
   */
  generateGuid(): string {
    return Math.random().toString(36).substring(2)
  }
}
